// extracted by mini-css-extract-plugin
module.exports = {"inputBox":"style_inputBox__36Vfc","btnUpload":"style_btnUpload__22izV","arrow":"style_arrow__1QE3D","title":"style_title__1oTan"};